
export interface FetchImplantTypesResponse {
  implant_types: ImplantTypesItemResponse[];
  message: string;
}

export interface ImplantTypesItemResponse {
  id: number,
  name: string
}